import { render, staticRenderFns } from "./CelebrationDetails.vue?vue&type=template&id=d35de92e&"
import script from "./CelebrationDetails.vue?vue&type=script&lang=js&"
export * from "./CelebrationDetails.vue?vue&type=script&lang=js&"
import style0 from "./CelebrationDetails.vue?vue&type=style&index=0&id=d35de92e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports